import React, { useEffect, Fragment, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Col, FormControl } from 'react-bootstrap';
import { getAllCourseRunDemands, setCourseRunDemandsStatus } from '../store/action/CourseAction';
import Head from '../../components/Head';
import Toast from '../../components/Toast';
import Loader from '../../components/Loader';
import { txtRT, txtTable, txtPage } from '../../utils/texts';
import { paramCase } from 'change-case';
import DarsUpTable from '../../components/table/DarsUpTable';
import { SelectColumnFilter } from '../../components/table/Filters';
import { PAGE_SIZE } from '../../utils/constants';
import Modal from 'react-bootstrap/Modal';
import { useForm } from 'react-hook-form';
import { Form } from 'reactstrap';

const CourseRunDemands = ({ history }) => {
  const [roleName, setRoleName] = useState('');

  const { courseRunDemands, isLoading, error, isAccepted } = useSelector(state => state.courseRunDemands);
  // const permission = useSelector((state) => state.permissionSelected.data);
  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  const params = new URLSearchParams(useLocation().search);

  const pageNumberQuery = Number(params.get('page'));

  const dispatch = useDispatch();

  const columns = React.useMemo(
    () => [
      {
        Header: txtTable.caption,
        accessor: 'title',
        hasSort: true,
      },
      {
        Header: txtTable.status,
        accessor: 'translated_status',
        Filter: SelectColumnFilter,
        filter: 'includes',
      },
      {
        Header: () => null,
        accessor: 'id',
      },
      {
        Header: 'عملیات',
        accessor: 'status',
        Cell: ({ row }) => {
          return (
            <>
              <a
                href={`https://courses.darsup.org/courses/${row.original.course_run_key}/course/`}
                className={'ml-auto'}
              >
                <Button>ادامه دوره در LMS</Button>
              </a>
              <a className={'ml-2'} href={`https://studio.darsup.org/course/${row.original.course_run_key}`}>
                <Button>ادامه دوره در studio</Button>
              </a>
            </>
          );
        },
      },
      {
        Header: ' ',
        accessor: 'test',
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ActionComponent
              id={row.values.id}
              courseStatus={row.values.status}
              handleChangeDemandStatusClick={(id, status, role) =>
                dispatch(setCourseRunDemandsStatus(role, row.values.id, status))
              }
            />
          );
        },
      },
    ],
    []
  );

  const fetchData = params => {
    let newParams;
    if (!params)
      newParams = {
        page: pageNumberQuery || 1,
        search: '',
        ordering: '',
      };
    else newParams = { ...params };
    dispatch(getAllCourseRunDemands(paramCase(selectedRole.name), PAGE_SIZE, newParams));
  };

  useEffect(() => {
    if (selectedRole?.role) {
      setRoleName(paramCase(selectedRole.name));
      if (paramCase(selectedRole.name) !== 'owner' && paramCase(selectedRole.name) !== 'course-creator')
        history.push('/');
      if (paramCase(selectedRole.name)) fetchData();
    }
  }, [permissions]);

  useEffect(() => {
    if (isAccepted) {
      Toast(txtRT.table.setAccepted, 'info');
      fetchData();
    }
    if (isAccepted == false) {
      Toast(txtRT.table.setRejected, 'info');
      fetchData();
    }
  }, [isAccepted]);

  return (
    <Fragment>
      <Head title="لیست دوره ها" />
      {courseRunDemands?.results && courseRunDemands?.results.length > 0 ? (
        <>
          <div className="kt-portlet p-3">
            <div className="kt-portlet__body">
              <DarsUpTable
                data={courseRunDemands.results}
                columns={columns}
                hasPagination={true}
                hasCounterColumn={true}
                // hasSearch={true}
                // hasFilter={true}
                // sortFields={['title']}
                fetchData={fetchData}
                count={courseRunDemands.count}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="kt-portlet p-3">
          <div className="kt-portlet__body">
            <div className="rounded bg-light my-3" style={{ minWidth: '60%' }}>
              <p className="h4 text-center px-2 py-5 mb-0">{txtPage.CourseRunDemands.notCourses.description}</p>
              <Link to="/courses/new">
                <Button>ایجاد دوره</Button>
              </Link>
            </div>
          </div>
        </div>
      )}
      <Loader visible={isLoading} />
    </Fragment>
  );
};

export const ActionComponent = ({ courseStatus, id, handleChangeDemandStatusClick, showlink = true, callback }) => {
  const permission = useSelector(state => state.permission.selectedRole);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorReason, setErrorReason] = useState(false);
  const { register, handleSubmit, errors, setError } = useForm();

  function submitErrorModal(values) {
    handleChangeDemandStatusClick('reject', values.message);
    // setShowErrorModal(false)
  }

  return (
    <>
      {(function(status) {
        return (
          <>
            {status == 1 && (
              <div style={{ textAlign: 'center' }}>
                <span
                  className={`btn btn-success`}
                  rel="noopener noreferrer"
                  onClick={() => handleChangeDemandStatusClick('accept')}
                >
                  تائید
                  <i className="fas fa-check ml-1"></i>
                </span>

                <Modal
                  show={showErrorModal}
                  onHide={() => {
                    setShowErrorModal(false);
                  }}
                  keyboard={false}
                  animation={true}
                >
                  <Modal.Header>
                    <Modal.Title>لطفا علت رد خود را وارد کنید</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form onSubmit={handleSubmit(submitErrorModal)}>
                      <FormControl
                        type={'textarea'}
                        name={'message'}
                        ref={register({ required: 'این فیلد الزامی است' })}
                      />
                      {errors?.message && (
                        <div>
                          <span className="text-danger">{errors.message.message}</span>
                        </div>
                      )}
                      <Button type={'submit'} className={'mt-3'}>
                        ثبت علت رد درخواست
                      </Button>
                    </Form>
                  </Modal.Body>
                </Modal>

                <span
                  className={`btn btn-danger ml-3`}
                  rel="noopener noreferrer"
                  onClick={() => setShowErrorModal(true)}
                >
                  رد
                  <i className="fas fa-times ml-1" />
                </span>
              </div>
            )}
          </>
        );
      })(courseStatus)}
    </>
  );
};

export default CourseRunDemands;
